<div class="modal-container-custom">
  <div class="modal-content-custom creditRatingStyle_1">
    <div class="modal-header">
      <button type="button" class="close cp-failure-btn back-button" aria-label="Close"
        (click)="activeModal.close(false)" aria-hidden="true">
        X
      </button>
      <h4 class="modal-title enabled-text">Update Credit Rating Details</h4>
    </div>
    <form autocomplete="off" class="form-section" [formGroup]="creditRatingForm" (ngSubmit)="onCreditRatingSubmit()">
      <div class="modal-body">

        <div class="dark-bg-info-card" formArrayName="creditListing"
          *ngFor="let creditRatingRow of creditRatingForm.get('creditListing')['controls']; let i = index;">
          <div class="row" [formGroupName]="i">
            <div class="col-md-12">
              <button *ngIf="i!== 0" type="button" class="close cp-failure-btn back-button" aria-label="Close"
                (click)="removeCreditLetter(i)">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="col-md-4">
              <div class="compt-input">
                <label for="credit-rating-agency-name">Agency
                  <span class="highlight-text">*</span>
                </label>
                <ng-select formControlName="name_of_credit_rating_agency" [items]="CREDIT_RATING_AGENCIES"
                  name="credit-rating-agency-name" class="icici-custom" [multiple]="false" [hideSelected]="true"
                  [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('name_of_credit_rating_agency').value"
                  [attr.id]="'name_of_credit_rating_agency-'+i">
                </ng-select>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['name_of_credit_rating_agency'].pristine) && creditRatingRow.controls['name_of_credit_rating_agency'].errors">
                  <small [hidden]="!creditRatingRow.controls['name_of_credit_rating_agency'].errors.required">
                    Credit rating agency is required.
                  </small>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="compt-input">
                <label for="credit-rating">Rating
                  <span class="highlight-text">*</span>
                </label>
                <ng-select formControlName="credit_rating" [items]="CREDIT_RATING_SHORT_TERM" name="credit-rating"
                  class="icici-custom" [multiple]="false" [hideSelected]="true"
                  [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('credit_rating').value"
                  [attr.id]="'credit_rating-'+i">
                </ng-select>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['credit_rating'].pristine) && creditRatingRow.controls['credit_rating'].errors">
                  <small [hidden]="!creditRatingRow.controls['credit_rating'].errors.required">
                    Credit rating is required.
                  </small>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="compt-input">
                <label>Date Of Credit Rating
                  <span class="highlight-text">*</span>
                </label>
                <div class="r-value-box">
                  <input
                    [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('date_of_credit_rating').value | json"
                    [attr.id]="'date_of_credit_rating-'+i" class="form-control attachement" [maxDate]="today"
                    [outsideDays]="'collapsed'" placeholder="dd/mm/yyyy" name="issue_maturity_date"
                    formControlName="date_of_credit_rating" ngbDatepicker #maturity="ngbDatepicker"
                    (click)="maturity.toggle()">
                  <div class="input-group-append icons-calender">
                    <button [attr.id]="'date_of_credit_rating_btn'+i" class="btn" (click)="maturity.toggle()"
                      type="button">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['date_of_credit_rating'].pristine) && creditRatingRow.controls['date_of_credit_rating'].errors">
                  <small [hidden]="!creditRatingRow.controls['date_of_credit_rating'].errors.required">
                    Maturity Date of agency certificate is required.
                  </small>
                  <small [hidden]="!creditRatingRow.controls['date_of_credit_rating'].errors.ngbDate">
                    Please select a past date.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="compt-input" ng-reflect-name="min_bid_value">
                <label>Amount
                  <span class="highlight-text">*</span>
                </label>
                <div class="r-value-box"><span class="icons-rs">₹</span>
                  <input [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('amountValue').value"
                    [attr.id]="'amountValue_'+i" class="form-control" formControlName="amountValue" min="0"
                    type="number" ng-reflect-name="amountValue">
                  <select [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('amountValueIn').value"
                    [attr.id]="'amountValueIn_'+i" class="form-control select-box" formcontrolname="amountValueIn"
                    ng-reflect-name="amountValueIn">
                    <option *ngFor="let amountObj of valueAmountIn">{{amountObj.amount}}</option>

                  </select>
                </div>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['amountValue'].pristine) && creditRatingRow.controls['amountValue'].errors">
                  <small [hidden]="!creditRatingRow.controls['amountValue'].errors.required">
                    Amount is required.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="compt-input">
                <label>
                  Validity for Issuance
                  <span class="highlight-text">*</span>

                  <i class="ml-2 fa fa-info-circle" placement="top"
                    ngbTooltip="Validity for Issuance which has to be shown on the documents."></i>
                </label>
                <div class="r-value-box">
                  <input
                    [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('validity_for_issuance').value"
                    [attr.id]="'validity_for_issuance_'+i" class="form-control attachement"
                    name="issue_validity_issuance" formControlName="validity_for_issuance" type="text">
                </div>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['validity_for_issuance'].pristine) && creditRatingRow.controls['validity_for_issuance'].errors">
                  <small [hidden]="!creditRatingRow.controls['validity_for_issuance'].errors.required">
                    Validity for Issuance is required.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="compt-input">
                <label>
                  Validity Period of Rating
                  <span class="highlight-text">*</span>
                  <i class="ml-2 fa fa-info-circle" placement="top"
                    ngbTooltip="Validity Period for Rating which has to be shown on the documents."></i>
                </label>
                <div class="r-value-box">
                  <input type="text"
                    [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('validity_period_for_rating').value"
                    [attr.id]="'validity_period_for_rating_'+i" class="form-control attachement"
                    formControlName="validity_period_for_rating" name="validity_period_for_rating">
                </div>

                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['validity_period_for_rating'].pristine) && creditRatingRow.controls['validity_period_for_rating'].errors">
                  <small [hidden]="!creditRatingRow.controls['validity_period_for_rating'].errors.required">
                    Validity Period for Rating is required.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="compt-input">
                <label>
                  Last date of Validity for Issuance
                  <span class="highlight-text">*</span>

                  <i class="ml-2 fa fa-info-circle" placement="top"
                    ngbTooltip="Date till which issuance can be done under the current credit rating letter."></i></label>
                <div class="r-value-box">
                  <input
                    [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('validity_for_issuance_expiry_date').value | json"
                    [attr.id]="'validity_for_issuance_expiry_date-'+i" class="form-control attachement"
                    [minDate]="today" [outsideDays]="'collapsed'" placeholder="dd/mm/yyyy"
                    name="credit-rating-issuance-expiry-date" formControlName="validity_for_issuance_expiry_date"
                    ngbDatepicker #issuanceExpiryDate="ngbDatepicker" (click)="issuanceExpiryDate.toggle()">
                  <div class="input-group-append icons-calender">
                    <button [attr.id]="'validity_for_issuance_expiry_date_btn'+i" class="btn"
                      (click)="issuanceExpiryDate.toggle()" type="button">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['validity_for_issuance_expiry_date'].pristine) && creditRatingRow.controls['validity_for_issuance_expiry_date'].errors">
                  <small [hidden]="!creditRatingRow.controls['validity_for_issuance_expiry_date'].errors.required">
                    Last date of Validity for Issuance is required.
                  </small>
                  <small [hidden]="!creditRatingRow.controls['validity_for_issuance_expiry_date'].errors.ngbDate">
                    Please select a future date.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="compt-input">
                <label>
                  Date of expiry of Credit Rating
                  <span class="highlight-text">*</span>

                  <i class="ml-2 fa fa-info-circle" placement="top"
                    ngbTooltip="Date till which credit rating is valid."></i>
                </label>
                <div class="r-value-box">
                  <input
                    [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('validity_period_for_rating_expiry_date').value | json"
                    [attr.id]="'validity_period_for_rating_expiry_date-'+i" class="form-control attachement"
                    [minDate]="today" [outsideDays]="'collapsed'" placeholder="dd/mm/yyyy"
                    name="credit-rating-expiry-date" formControlName="validity_period_for_rating_expiry_date"
                    ngbDatepicker #ratingExpiryDate="ngbDatepicker" (click)="ratingExpiryDate.toggle()">
                  <div class="input-group-append icons-calender">
                    <button [attr.id]="'validity_period_for_rating_expiry_date_btn'+i" class="btn"
                      (click)="ratingExpiryDate.toggle()" type="button">
                      <i class="far-i fa fa-calendar"></i>
                    </button>
                  </div>
                </div>
                <div class="error-text"
                  *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['validity_period_for_rating_expiry_date'].pristine) && creditRatingRow.controls['validity_period_for_rating_expiry_date'].errors">
                  <small [hidden]="!creditRatingRow.controls['validity_period_for_rating_expiry_date'].errors.required">
                    Date of expiry of credit rating is required.
                  </small>
                  <small [hidden]="!creditRatingRow.controls['validity_period_for_rating_expiry_date'].errors.ngbDate">
                    Please select a future date.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <div class="compt-input">
                <label>Conditions (if any)
                  <span class="highlight-text">*</span>
                </label>
                <div class="r-value-box">
                  <input [attr.value]="creditRatingForm.get('creditListing')['controls'][i].get('conditions_if_any').value"
                    [attr.id]="'conditions_if_any_'+i" class="form-control padding-10px text-align-initial"
                    formControlName="conditions_if_any">
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="dark-bg-info-card upload-box">
                <div class="row">
                  <div class="col-md-12">
                    <div class="compt-input">
                      <label>Upload Credit Rating Letter
                        <span class="highlight-text">*</span>
                      </label>
                      <div class="row">
                        <div class="col-md-6">
                          <app-upload-button [attr.id]="'upload_credit_ratings_paper'+i" 
                          [componentId]="'upload_credit_ratings'+i" #uploadComp
                            [uploadType]="'KEY'" (fileAsDataURL)="onUploadCreditRatingsChange($event, creditRatingRow)"
                            [fileTypes]="fileTypes">
                          </app-upload-button>
                          <small>{{uploadComp.fileName}}</small>
                          <small>
                            <a *ngIf="!uploadComp.fileName && creditRatingRow.controls['credit_rating_file_url'].value"
                              (click)="viewDocument(creditRatingRow.controls['credit_rating_file_url'].value)" [href]=""
                              target="_blank" rel="noopener noreferrer">View existing
                              Credit Rating Letter.</a>
                          </small>
                          <div class="error-text"
                            *ngIf="(formSubmittedInvalid || !creditRatingRow.controls['credit_rating_document'].pristine) && creditRatingRow.controls['credit_rating_document'].errors">
                            <small [hidden]="!creditRatingRow.controls['credit_rating_document'].errors.required">
                              Credit Rating Letter is required.
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-1"></div>
          <div
            class="btn btn-outline-secondary btn-sm btn-block new-issue-btn col-md-10 col-offset-1 align-center"
            id="add-new-credit-rating" (click)="addCreditLetter()">Add
            More +</div>
        </div>

      </div>
      <hr class="dashed-border-top">
      <div class="modal-footer modal-footer-custom no-border">
        <button type="button" id="cancel-credit-rating-modal" class="col-md-4 btn btn-outline-normal text-left"
          (click)="activeModal.close()">Cancel</button>
        <button type="submit" id="save-credit-rating-modal"
          class="col-md-4 btn btn-success for-icon-right for-right-arrow text-left">Save</button>
      </div>
    </form>

  </div>
</div>